import React from 'react';
import CustomMarker from '../../../assets/icons/location-marker--red.svg';

export const Marker: React.FC<google.maps.MarkerOptions> = options => {
  const [marker, setMarker] = React.useState<google.maps.Marker>();

  const icon = {
    url: CustomMarker,
    anchor: new google.maps.Point(30, 30),
  };

  React.useEffect(() => {
    if (!marker) {
      setMarker(
        new google.maps.Marker({
          icon: icon,
        })
      );
    }

    // remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  React.useEffect(() => {
    if (marker) {
      marker.setOptions(options);
    }
  }, [marker, options]);

  return null;
};
